import { cn } from 'lib/utils';
import * as React from 'react';

/**
 * The frame of a screen: a column that fills the shell, with the top bar
 * first and a `PageContent` that scrolls.
 */
function Page({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="page"
      className={cn('relative flex h-full min-h-0 flex-col items-center overflow-hidden bg-background', className)}
      {...props}
    />
  );
}

/**
 * The scrolling column of a screen, centred at the content width.
 *
 * `*:shrink-0` matters: this is a flex column, and a child that clips its own
 * overflow (a card) would otherwise be squashed to fit the viewport instead
 * of pushing the column into scrolling.
 */
function PageContent({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="page-content"
      className={cn('flex min-h-0 w-full max-w-content grow flex-col gap-6 overflow-y-auto p-4 *:shrink-0', className)}
      {...props}
    />
  );
}

export { Page, PageContent };
